module.exports = __webpack_public_path__ + "static/img/kjdy1.d969aaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/kjdy1.png
// module id = 324
// module chunks = 0